import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'app-portfolio-recommendation',
    templateUrl: './portfolio-recommendation.component.html',
    styleUrls: ['./portfolio-recommendation.component.css']
})
export class PortfolioRecommendationComponent implements OnInit {

    @Input() year: string = '';
    @Input() clientAge: string = '';
    @Input() spouseAge: string = '';
    @Input() clientRetirementAge: string = '';
    @Input() spouseRetirementAge: string = '';
    @Input() phase1Val: string = '';
    @Input() phase2Val: string = '';
    @Input() singleInvestment: string = '';
    @Input() unfundedAmount: string = '';
    @Input() phase1Portfolio = '';
    @Input() phase2Portfolio = '';
    @Input() isAlreadyRetired: boolean;

    constructor() {

    }

    ngOnInit() {
        
    }

    ngOnChanges(changes) {
        if (changes.clientRetirementAge && changes.clientRetirementAge.currentValue) {
            const clientDiff = Math.max(0, Number(changes.clientRetirementAge.currentValue) - Number(changes.clientAge.currentValue));
            const spouseDiff = Math.max(0, Number(changes.spouseRetirementAge.currentValue) - Number(changes.spouseAge.currentValue));
            
            if (clientDiff < spouseDiff) {
                this.spouseRetirementAge = (Number(changes.spouseAge.currentValue) + Math.max(0, Number(changes.clientRetirementAge.currentValue) - Number(changes.clientAge.currentValue))).toString();
            } else if (clientDiff > spouseDiff) {
                this.clientRetirementAge = (Number(changes.clientAge.currentValue) + Math.max(0, Number(changes.spouseRetirementAge.currentValue) - Number(changes.spouseAge.currentValue))).toString();
            }
        }
    }

}
